define('modules/audiences/segments/create/main',["jQuery", "T1", "T1Module"], function ($, T1, T1Module) {
  "use strict";

  var instance;
  if (instance === undefined) {
    instance = new T1Module({
      name: "audiences/segments/create",
      viewCfgs: {
        segments: {}
      },
      defaultView: "createEdit"
    });
  }
  return instance;
});
